import axios from 'axios'  //引入axios
import router from './router'  //引入路由实例
import { getUserInfo } from './utils/auth'  //引入获取用户信息的函数

// 使用空字符串作为baseURL，配合vue.config.js中的代理配置
// 这样所有请求都会通过vue.config.js中配置的代理进行转发
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL, // 这里使用/api前缀，与vue.config.js中的代理配置对应
    timeout: 20000    //设置超时时间，超过该时间就不会发起请求
})

// 请求拦截器，在发送请求前要做的事，例如设置请求头，统一的请求参数等
service.interceptors.request.use(
    config => {
        // 设置Content-Type
        if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json;charset=utf-8'
        }

        // 从本地存储获取token并设置到请求头
        const token = localStorage.getItem('token')

        const isToken = (config.headers || {}).isToken === false
        if (token && !isToken) {
            config.headers['Authorization'] = 'Bearer ' + token
        }

        // 添加公司ID到请求头
        const userInfo = getUserInfo()
        if (userInfo && userInfo.company_id) {
            config.headers['company-id'] = userInfo.company_id
        }

        // 添加app_key到请求头
        // config.headers['app_key'] = 'SkRWT1BXNmROaGJHdlR5Ng=='

        // 添加Origin请求头
        // config.headers['Origin'] = 'https://central.saas361.cn'

        return config
    },
    error => {
        console.log('请求错误:', error)
        return Promise.reject(error)
    })

// 响应拦截器，对请求后等到响应的数据进行处理
service.interceptors.response.use(
    response => {
        // 请求成功处理
        const res = response.data

        // 根据后端约定的状态码处理
        if (res.code == 200 || res.code == 0) {
            return res
        } else if (res.code == 401) {
            // 未授权，清除token并重定向到登录页
            localStorage.removeItem('token')
            // 使用router重定向到登录页面
            router.push('/login')
            console.error('登录已过期，请重新登录')
        } else {
            console.error('请求失败:', res.message || '未知错误')
            return Promise.reject(new Error(res.message || 'Error'))
        }
    },
    error => {
        // 请求失败处理
        if (error.response) {
            console.log('响应错误状态码:', error.response)
            // 服务器响应了，但状态码不是2xx
            switch (error.response.code) {
                case 401:
                    // 未授权，清除token并重定向到登录页
                    localStorage.removeItem('token')
                    // 使用router重定向到登录页面
                    router.push('/login')
                    console.error('登录已过期，请重新登录')
                    break
                case 403:
                    console.error('没有权限访问该资源')
                    break
                case 404:
                    console.error('请求的资源不存在')
                    break
                case 500:
                    console.error('服务器内部错误')
                    break
                default:
                    console.error('请求失败:', error.response.data.message || '未知错误')
            }
        } else if (error.request) {
            // 请求已发出，但没有收到响应
            console.error('网络错误，请检查网络连接')
        } else {
            // 请求配置出错
            console.error('请求配置错误:', error.message)
        }
        return Promise.reject(error)
    }
)

// 对外暴露
export default service